import { AcwMessageBus } from "@blk/acw-message-bus";
import { batch } from "react-redux";
const DEFAULT_CHANNEL = "MAIN_CHANNEL", DEFAULT_TOPIC = "MAIN_TOPIC";
export const COMMITMENTPACING_ASOFDATE_KEY = "asOfDate";
export const OPERATION_UPDATED = "operation-updated";
export const WIDGET_CONTEXT_UPDATED = "widget-context-updated";
export const CONNECTION_ID_UPDATED = "connection-id-updated";
export const STATE_INITIALIZING = "state_initializing";
export const COMMITMENTPACING_ASOFDATE_CHANGED = "commitmentPacing_asOfDate_changed";
export const TELEMETRY_EVENT_PUBLISHED = "telemetry-event-published";
export const USER_SETTINGS_CHANGED = "user-settings-changed";
export const LAST_SYNC_DATE_UPDATED = "last-sync-date-updated";
const getTopic = () => AcwMessageBus.getInstance()
    .channel(DEFAULT_CHANNEL)
    .topic(DEFAULT_TOPIC);
const pipes = [];
const dispatchActions = (actions, dispatch) => {
    if (actions.length) {
        batch(() => {
            let action = actions.pop();
            while (action) {
                dispatch(action);
                action = actions.pop();
            }
        });
    }
};
export const subscribeToMessageBus = (subject, reactions) => {
    let pipe = pipes.find((p) => p.subject === subject);
    if (!pipe) {
        pipe = { reactions: [], subject };
        pipes.push(pipe);
    }
    if (!pipe.reactions.includes(reactions)) {
        pipe.reactions.push(reactions);
    }
};
export const publishToMessageBus = (key, value) => getTopic().next({ key, value });
export const busMiddleware = ({ dispatch }) => {
    const topic = getTopic();
    const actions = [];
    topic.subscribe({
        next: (data) => {
            const pipe = pipes.find((p) => p.subject === data.key);
            if (pipe?.reactions?.length) {
                for (const reaction of pipe.reactions) {
                    const { actions: reactions, callback: call } = reaction(data.value);
                    if (reactions?.length) {
                        for (const action of reactions) {
                            actions.push(action);
                        }
                    }
                    call?.();
                }
                // For messages that are sent outside of a reducer
                setTimeout(() => dispatchActions(actions, dispatch), 10);
            }
        }
    });
    return (next) => (action) => {
        dispatchActions(actions, dispatch);
        return next(action);
    };
};
